// aws api profiles
import api from '../../aws/api/profiles/json.profile.api.aws';

const loadJsonAwsApiGenerator = (file) => (supplierId) =>
  api().get(`/data/supplier/${supplierId}/${file}.json`);

export default loadJsonAwsApiGenerator;
